import Button from "../../../../../components/button/button";
import { FiEdit, FiFilter, FiTrash } from "react-icons/fi";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../../../../components/table/table";
import { getApiInstance } from "../../../../../utils/api";
import Popup from "../../../../../components/popup/popup";
import Notification from "../../../../../components/notification/notification";
import Tag from "../../../../../components/tag/tag";
import Accordion from "../../../../../components/accordion/accordion";
import Modal from "../../../../../components/modal/modal";
import InputDropdownSimple from "../../../../../components/inputs/inputDropdownSimple/inputDropdownSimple";
import Input from "../../../../../components/inputs/input/input";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import { BiExport } from "react-icons/bi";
import { searchByKeywords } from "../../../../../utils/searchUtils";


export const Usuarios = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [filterEmpresasSelected, setFilterEmpresasSelected] = useState([]);
    const [filterRolSelected, setFilterRolSelected] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userAEliminar, setUserAEliminar] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const notificationRef = useRef(null);
    const [nombreError, setNombreError] = useState("");
    const [apellidosError, setApellidosError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [rolError, setRolError] = useState("");
    const [currentUser, setCurrentUser] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState([]);

    const [newUser, setNewUser] = useState({
        nombre: "",
        apellidos: "",
        email: "",
        password: "",
        rol: "",
        codEmpresa: "",
    });

    const openModal = () => {
        setSelectedUser(null);
        setNewUser({
            nombre: "",
            apellidos: "",
            email: "",
            password: "",
            rol: "",
            codEmpresa: "",
        });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setNewUser({
            nombre: "",
            apellidos: "",
            email: "",
            password: "",
            rol: "",
            codEmpresa: "",
        });
    };

    const columnsUsuarios = [
        { key: "", label: "" },
        { key: "nombre", label: "Nombre" },
        { key: "apellidos", label: "Apellidos" },
        { key: "email", label: "Email" },
        { key: "rol", label: "Rol" },
        { key: "empresa", label: "Empresa" },
    ];

    useEffect(() => {
        fetchCurrentUser();
        fetchEmpresas();
    }, []);

    const fetchCurrentUser = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                "/api/Usuario/GetCurrentUserWithEmpresa"
            );
            const userData = response.data;
            setCurrentUser(userData);
            fetchEmpresas(userData.codTipoEmpresa, userData.codEmpresa); // Filtramos empresas según el tipo de empresa
            fetchUsers();
        } catch (error) {
            console.error("Error al obtener usuario actual:", error);
        }
    };

    const fetchUsers = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                "/api/Usuario/GetUsuariosByPermisos"
            );
            setUsers(response.data);
            setFilteredUsers(response.data);

        } catch (error) {
            console.error("Error al obtener usuarios:", error);
            setUsers([]);
        }
    };

    const fetchEmpresas = async (codTipoEmpresa, codEmpresa) => {
        const api = getApiInstance();
        try {
            const response = await api.get("/api/Empresa/GetAllEmpresas");
            let empresasFiltradas = response.data;

            if (codTipoEmpresa === 3) {
                // Solo mostrar la empresa a la que pertenece el usuario
                empresasFiltradas = empresasFiltradas.filter(
                    (emp) => emp.codEmpresa === codEmpresa
                );
            } else if (codTipoEmpresa === 2) {
                // Mostrar todas excepto Grupo Atlante (codEmpresa = 1)
                empresasFiltradas = empresasFiltradas.filter(
                    (emp) => emp.codEmpresa !== 1
                );
            }
            // Si es codTipoEmpresa === 1, no se filtra nada (ve todas las empresas)
            const empresasTransformadas = empresasFiltradas.map((item) => ({
                value: item.codEmpresa,
                label: item.nombre,
            }));

            setEmpresas(empresasTransformadas);
        } catch (error) {
            console.error("Error al obtener las empresas:", error);
            setEmpresas([]);
        }
    };
    useEffect(() => {
    const enrichedUsers = users.map((user) => ({
        ...user,
        empresa:
            empresas.find((empresa) => empresa.value === user.codEmpresa)
                ?.label || "Empresa no encontrada",
    }));

    let result = enrichedUsers;

    if (filterEmpresasSelected.length > 0) {
        result = result.filter((user) =>
            filterEmpresasSelected.includes(user.empresa)
        );
    }

    if (filterRolSelected.length > 0) {
        result = result.filter((user) =>
            filterRolSelected.includes(user.rol)
        );
    }

    const campos = ["nombre", "apellidos", "email", "rol", "empresa"];
    result = searchByKeywords(result, searchTerm, campos);

    setFilteredUsers(result);
}, [users, empresas, filterEmpresasSelected, filterRolSelected, searchTerm]);

    // const filteredUsers = useMemo(() => {
    //     return users
    //     .map((user) => {
    //         return {
    //             ...user,
    //             empresa:
    //                 empresas.find(
    //                     (empresa) => empresa.value === user.codEmpresa
    //                 )?.label || "Empresa no encontrada",
    //         };
    //     })        
    //         .filter(
    //             (user) =>
    //                 filterEmpresasSelected.length === 0 ||
    //                 filterEmpresasSelected.includes(user.empresa)
    //         )
    //         .filter(
    //             (user) =>
    //                 filterRolSelected.length === 0 ||
    //                 filterRolSelected.includes(user.rol)
    //         )
    //         .filter((user) =>
    //             Object.values(user).some((value) =>
    //                 value
    //                     ? value
    //                           .toString()
    //                           .toLowerCase()
    //                           .includes(searchTerm.toLowerCase())
    //                     : false
    //             )
    //         );
    // }, [
    //     searchTerm,
    //     users,
    //     empresas,
    //     filterEmpresasSelected,
    //     filterRolSelected,
    // ]);

    if (!currentUser) {
        return <p>Cargando...</p>;
    }
    const handleEditUser = (user) => {
        setSelectedUser(user);
        setNewUser({
            codUsuario: user.codUsuario,
            nombre: user.nombre,
            apellidos: user.apellidos,
            email: user.email,
            password: user.password,
            rol: user.rol,
            codEmpresa: user.codEmpresa,
        });
        setIsModalOpen(true);
    };

    const confirmDeleteUser = (user) => {
        setUserAEliminar(user);
        setIsPopupOpen(true);
    };

    const actions = (row) => [
        {
            label: "Editar",
            onClick: () => handleEditUser(row),
            icon: <FiEdit />,
        },
        {
            label: "Eliminar",
            onClick: () => confirmDeleteUser(row),
            icon: <FiTrash />,
        },
    ];

    const handleAddOrEditUser = async () => {
        setNombreError("");
        setApellidosError("");
        setEmailError("");
        setPasswordError("");
        setRolError("");

        let hasError = false;

        if (!newUser.nombre) {
            setNombreError("El campo nombre es obligatorio.");
            hasError = true;
        }
        if (!newUser.apellidos) {
            setApellidosError("El campo apellidos es obligatorio.");
            hasError = true;
        }
        if (!newUser.email) {
            setEmailError("El campo email es obligatorio.");
            hasError = true;
        }
        if (!newUser.password) {
            setPasswordError("El campo contraseña es obligatorio.");
            hasError = true;
        }
        if (newUser.rol === "selecciona") {
            setRolError("Debes seleccionar un rol.");
            hasError = true;
        }

        const userToSubmit = {
            ...newUser,
            codEmpresa: newUser.codEmpresa === "" ? null : newUser.codEmpresa,
        };

        if (hasError) return;

        const api = getApiInstance();
        try {
            if (newUser.codUsuario) {
                await api.put(`/api/Usuario/${newUser.codUsuario}`, newUser);
                notificationRef.current.addNotification(
                    "Usuario actualizado con éxito.",
                    "success"
                );
            } else {
                await api.post("/api/Usuario", newUser);
                notificationRef.current.addNotification(
                    "Usuario añadido con éxito.",
                    "success"
                );
            }
            fetchUsers();
            closeModal();
        } catch (error) {
            console.error("Error al guardar usuario:", error);
            notificationRef.current.addNotification(
                error.response?.data?.message || "Error al guardar usuario.",
                "warning"
            );
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    const handleCleanFilter = () => {
        setFilterEmpresasSelected([]);
        setFilterRolSelected([]);
    };

    const handleSelectEmpresa = (nombreEmpresa) => {
        setFilterEmpresasSelected((prevSelected) => {
            if (prevSelected.includes(nombreEmpresa)) {
                return prevSelected.filter(
                    (empresa) => empresa !== nombreEmpresa
                );
            } else {
                return [...prevSelected, nombreEmpresa];
            }
        });
    };

    const handleSelectRol = (rolName) => {
        setFilterRolSelected((prevSelected) => {
            if (prevSelected.includes(rolName)) {
                return prevSelected.filter((rol) => rol !== rolName);
            } else {
                return [...prevSelected, rolName];
            }
        });
    };

    const handleConfirmDelete = async () => {
        const api = getApiInstance();
        try {
            await api.delete(`/api/Usuario/${userAEliminar.codUsuario}`);
            setUsers(
                users.filter(
                    (user) => user.codUsuario !== userAEliminar.codUsuario
                )
            );
            notificationRef.current.addNotification(
                "Usuario eliminado correctamente.",
                "success"
            );
        } catch (error) {
            console.error("Error al eliminar usuario:", error);
            const errorMessage =
                error.response?.data?.message || "Error al eliminar usuario.";
            notificationRef.current.addNotification(errorMessage, "error");
        } finally {
            setIsPopupOpen(false);
        }
    };

    const handleExportExcel = async () => {
        try {
            const api = getApiInstance();
            const response = await api.post(
                `/api/Usuario/ExportarUsuarios/${currentUser.codUsuario}`,
                null,
                { responseType: "blob" }
            );

            if (response.status !== 200) {
                throw new Error("Error al descargar el archivo");
            }

            const blob = await response.data;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;

            let fecha = new Date();
            let dia = String(fecha.getDate()).padStart(2, '0');
            let mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript van de 0 a 11
            let año = fecha.getFullYear();
            
            let fileName = `Usuarios_${dia}_${mes}_${año}.xlsx`;

            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            notificationRef.current.addNotification(
                "Archivo descargado correctamente.",
                "success"
            );
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al descargar el archivo.",
                "error"
            );
            console.error("Error al descargar el archivo:", error);
        }
    };

    return (
        <>
            <div className="dashboard-usuarios__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={setSearchTerm}
                />

                <div className="dashboard-usuarios__content__table-header__buttons">
                    <Button
                                            label="Exportar"
                                            variant="outline"
                                            icon={<BiExport />}
                                            onClick={handleExportExcel}
                                        />
                    <Button
                        variant="outline"
                        label="Filtros"
                        icon={<FiFilter />}
                        onClick={() => setIsFiltersModalOpen(true)}
                    />

                    <Button
                        label="Añadir usuario"
                        variant="filled"
                        onClick={openModal}
                    />
                </div>
            </div>

            <Table
                columns={columnsUsuarios}
                data={filteredUsers}
                actions={actions}
                showHeaderCheckbox={false}
                noResultsMessage="No se ha encontrado ningún resultado."
            />

            <Modal
                title={selectedUser ? "Editar Usuario" : "Añadir Usuario"}
                isOpen={isModalOpen}
                onClose={closeModal}
                onAccept={handleAddOrEditUser}
            >
                <div className="dashboard-usuarios__modal">
                    <form
                        className="dashboard-usuarios__modal__content"
                        autoComplete="off"
                    >
                        <Input
                            type="text"
                            label="Nombre"
                            name="nombre"
                            value={newUser.nombre}
                            placeholder="Introduce el nombre del usuario"
                            onChange={handleInputChange}
                        />

                        {nombreError && <p className="error">{nombreError}</p>}

                        <Input
                            type="text"
                            label="Apellidos"
                            name="apellidos"
                            value={newUser.apellidos}
                            placeholder="Introduce los apellidos del usuario"
                            onChange={handleInputChange}
                        />

                        {apellidosError && (
                            <p className="error">{apellidosError}</p>
                        )}

                        <Input
                            type="text"
                            label="Email"
                            name="email"
                            value={newUser.email}
                            placeholder="Introduce el email del usuario"
                            onChange={handleInputChange}
                        />

                        {emailError && <p className="error">{emailError}</p>}

                        <Input
                            type="password"
                            label="Contraseña"
                            name="password"
                            value={newUser.password}
                            placeholder="Introduce la contraseña"
                            onChange={handleInputChange}
                        />

                        {passwordError && (
                            <p className="error">{passwordError}</p>
                        )}

                        <InputDropdownSimple
                            label="Rol"
                            placeholder="Selecciona rol"
                            options={[
                                {
                                    value: "Administrador",

                                    label: "Administrador",
                                },

                                { value: "Usuario", label: "Usuario" },
                            ]}
                            value={newUser.rol}
                            onSelect={(selectedOption) =>
                                handleInputChange({
                                    target: {
                                        name: "rol",

                                        value: selectedOption.value,
                                    },
                                })
                            }
                        />

                        {rolError && <p className="error">{rolError}</p>}

                        <InputDropdown
                            options={empresas}
                            onSelect={(selectedOption) =>
                                handleInputChange({
                                    target: {
                                        name: "codEmpresa",
                                        value: selectedOption.value,
                                    },
                                })
                            }
                            value={
                                empresas.filter(
                                    (x) => x.value === newUser.codEmpresa
                                )[0]
                            }
                            placeholder="Nombre de la empresa"
                            label="Empresa"
                            showLabel={true}
                        />

                        {/* <InputDropdownAdd
                            options={empresas}
                            value={
                                empresas.filter(
                                    (x) => x.value === newUser.codEmpresa
                                )[0]
                            }
                            onSelect={(selectedOption) =>
                                handleInputChange({
                                    target: {
                                        name: "codEmpresa",

                                        value: selectedOption.value,
                                    },
                                })
                            }
                            // onAddOption={handleAddOptionEmpresa}
                            placeholder="Nombre de la empresa"
                            label="Empresa"
                        /> */}
                    </form>
                </div>
            </Modal>

            <Modal
                title="Filtros"
                isOpen={isFiltersModalOpen}
                onClose={() => setIsFiltersModalOpen(false)}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${filteredUsers.length})`}
                onCancel={handleCleanFilter}
            >
                <div className="section-header__modal__section">
                    <Accordion title="Empresa">
                        <ul className="section-header__modal__section__content">
                            {empresas.map((empresa, index) => (
                                <Tag
                                    key={index}
                                    label={empresa.label}
                                    isSelected={filterEmpresasSelected.includes(
                                        empresa.label
                                    )}
                                    onSelect={handleSelectEmpresa}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>

                <div className="section-header__modal__section">
                    <Accordion title="Rol">
                        <ul className="section-header__modal__section__content">
                            <Tag
                                label="Administrador"
                                isSelected={filterRolSelected.includes(
                                    "Administrador"
                                )}
                                onSelect={handleSelectRol}
                            />

                            <Tag
                                label="Usuario"
                                isSelected={filterRolSelected.includes(
                                    "Usuario"
                                )}
                                onSelect={handleSelectRol}
                            />
                        </ul>
                    </Accordion>
                </div>
            </Modal>

            <Notification ref={notificationRef} />

            {isPopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage={`¿Estás seguro de que deseas eliminar al usuario ${userAEliminar.nombre}?`}
                    onConfirm={handleConfirmDelete}
                    onClose={() => setIsPopupOpen(false)}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )}
        </>
    );
};
